import { useState } from "react";
import "../../styles/reportEditorSetting.css";

const FONT_SIZES = ["NONE", "8", "10", "11", "12", "14", "16", "18", "20", "24", "28", "32"];
const FONT_FAMILIES = ["NONE", "Arial", "Times New Roman", "Calibri", "Verdana", "Georgia", "Courier New", "Tahoma", "Trebuchet MS"];

export default function ReportEditorSetting({ isOpen, onClose, onSubmit }) {
  const [fontSize,         setFontSize]         = useState("NONE");
  const [fontFamily,       setFontFamily]       = useState("NONE");
  const [hidePreview,      setHidePreview]      = useState(false);
  const [disableAI,        setDisableAI]        = useState(false);
  const [showAttachImages, setShowAttachImages] = useState(false);
  if (!isOpen) return null;
  function handleSubmit() {
    onSubmit?.({ fontSize, fontFamily, hidePreview, disableAI, showAttachImages });
    onClose?.();
  }
  function handleBackdrop(e) {
    if (e.target === e.currentTarget) onClose?.();
  }
  const TOGGLES = [
    { key: "hidePreview",      label: "Hide report preview while reporting", value: hidePreview,      setter: setHidePreview      },
    { key: "disableAI",        label: "Disable AI editor",                   value: disableAI,        setter: setDisableAI        },
    { key: "showAttachImages", label: "Show attach study images in preview", value: showAttachImages, setter: setShowAttachImages },
  ];
  return (
    <div className="res-backdrop" onMouseDown={handleBackdrop}>
      <div className="res-modal">
        {/* Title */}
        <h2 className="res-title">Report editor setting</h2>
        {/* Subtitle */}
        <p className="res-subtitle">Setting to customize study table interface</p>
        {/* Default font size */}
        <div className="res-field">
          <label className="res-field-label">Default font size of editor</label>
          <select
            className="res-select"
            value={fontSize}
            onChange={(e) => setFontSize(e.target.value)}
          >
            {FONT_SIZES.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>
        {/* Default font family */}
        <div className="res-field">
          <label className="res-field-label">Default font family of editor</label>
          <select
            className="res-select"
            value={fontFamily}
            onChange={(e) => setFontFamily(e.target.value)}
          >
            {FONT_FAMILIES.map((f) => (
              <option key={f} value={f}>{f}</option>
            ))}
          </select>
        </div>
        {/* Toggle rows */}
        {TOGGLES.map(({ key, label, value, setter }) => (
          <div key={key} className="res-toggle-row">
            <span className="res-toggle-label">{label}</span>
            <div
              className={`res-toggle ${value ? "res-toggle--on" : ""}`}
              onClick={() => setter((v) => !v)}
              role="switch"
              aria-checked={value}
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && setter((v) => !v)}
            >
              <div className="res-toggle-thumb" />
            </div>
          </div>
        ))}
        {/* Submit */}
        <button className="res-submit-btn" onClick={handleSubmit}>
          SUBMIT
        </button>
        {/* Close */}
        <div className="res-close-row">
          <button className="res-close-btn" onClick={onClose}>CLOSE</button>
        </div>
      </div>
    </div>
  );
}